/* unplugin-vue-components disabled */import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.object.to-string.js";
import { mapState } from 'vuex';
export default {
  name: 'iHeaderSearch',
  computed: _objectSpread(_objectSpread({}, mapState('admin/layout', ['isDesktop', 'headerMenu'])), {}, {
    routerList: function routerList() {
      return this.$store.state.admin.menu.dynamicRouters.map(function (item) {
        return item.children;
      }).filter(function (item) {
        return item && item.length > 0;
      }).reduce(function (a, b) {
        a.push(b);
        return a;
      }).map(function (item) {
        return item.meta.title;
      });
    }
  }),
  methods: {
    handleCloseSearch: function handleCloseSearch() {
      this.$refs.dropdown.handleClick();
    },
    filterMethod: function filterMethod(value, option) {
      return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
    }
  }
};